var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modals',{staticClass:"impact-form-prompt-order-modal",attrs:{"title":'Change Prompt Order',"validateBeforeClose":_vm.validateBeforeClose,"display":_vm.display,"parentTag":'form',"novalidate":'novalidate',"fullMobile":true},on:{"show":_vm.cancelAction},scopedSlots:_vm._u([{key:"modal-content",fn:function(){return [_c('div',{staticClass:"prompt-order"},[(_vm.display)?_c('FieldPromptDragableList',{attrs:{"editMode":false,"mapping":_vm.fieldPromptMapping},model:{value:(_vm.inputFieldsData),callback:function ($$v) {_vm.inputFieldsData=$$v},expression:"inputFieldsData"}}):_vm._e()],1)]},proxy:true},{key:"modal-footer",fn:function(){return [_c('ButtonGroup',{attrs:{"items":[
				{
					id: 'saveButtonModal',
					className: 'btn--primary',
					labelText: 'Save Changes',
					type: 'submit',
					btnClick: _vm.saveAction,
					disabled: !_vm.pendingChanges
				},
				{
					id: 'cancelButtonModal',
					className: 'btn--link',
					labelText: 'Cancel',
					btnClick: _vm.cancelAction
				}
			]}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }